import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierMinusFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 11C1 6 3.5 1 11 1s10 5 10 10c0 2.419-.585 4.837-2.038 6.69l4.034 4.034-1.272 1.272-4.026-4.025C16.142 20.22 13.96 21 11 21 3.5 21 1 16 1 11m5-.9v1.8h10v-1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MagnifierMinusFilledSize24Glyph.displayName = 'MagnifierMinusFilledSize24Glyph';
